module.exports = __webpack_public_path__ + "img/visa.a95a84a0.svg";